
export const topSliderControl = (): void => {
  let currentSlide = 0

  const topBannerWrapper = document.querySelector('.js-topSlider') as unknown as HTMLElement

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!topBannerWrapper || !bodyElement) {
    return
  }

  const navigateSlide = (navigationDot: HTMLElement) => {
    if (navigationDot.classList.contains('-active')) {
      return
    }

    const navigationID = navigationDot.dataset.slide_nav_id

    const matchingSlide = slideList.find((slide) => {
      return slide.dataset.slide_id === navigationID
    })
    if (matchingSlide) {
      clearInterval(slideInterval)
      slideInterval = setSlideInterval()

      animateSlide(matchingSlide)
    }
  }

  const cleanSlides = (): void => {
    slideList.forEach((slide: HTMLElement) => {
      slide.classList.remove('-active')
      const allTitleSpans = slide.querySelectorAll('.js-topSlider-title span') as unknown as NodeListOf<HTMLElement>
      const allSubtitleSpans = slide.querySelectorAll('.js-topSlider-subTitle span') as unknown as NodeListOf<HTMLElement>

      const linkElement = slide.querySelector('.js-topSlider-link') as unknown as HTMLElement

      linkElement.classList.add('-fadeout')

      allTitleSpans.forEach((span: HTMLElement) => {
        span.style.transitionDelay = '0ms'
        span.style.transitionDuration = '600ms'
        span.classList.add('-fadeout')
      })

      allSubtitleSpans.forEach((span: HTMLElement) => {
        span.style.transitionDelay = '0ms'
        span.style.transitionDuration = '600ms'
        span.classList.add('-fadeout')
      })
    })
  }

  const animateSlide = (slide: HTMLElement): void => {
    cleanSlides()

    const navigationID = slide.dataset.slide_id

    // Add active class to nav dot and remove the rest
    navigationDots.forEach(dot => {
      dot.classList.remove('-active')
    })
    let matchingNavDotIndex = 0
    const matchingNavDot = navigationDots.find((dot, index) => {
      if (dot.dataset.slide_nav_id === navigationID) {
        matchingNavDotIndex = index
        return true
      }
      else {
        return false
      }
    })
    if (matchingNavDot && matchingNavDot.dataset.slide_nav_id) {
      matchingNavDot.classList.add('-active')
      if (currentSlide < slideList.length - 1) {
        currentSlide = matchingNavDotIndex + 1
      }
      else {
        currentSlide = 0
      }
    }

    // Wait for cleanup to finish
    setTimeout(() => {
      // Animate actual slide
      slide.classList.add('-active')

      function splitWords (selector: string, delayTimer = 300, callback?: () => void, timeout = 0) {
        let quote = slide.querySelector(selector) as unknown as HTMLElement
        if (!quote) {
          return
        }
        quote.innerText.replace(/(<([^>]+)>)/ig, '')
        let quotewords = quote.innerText.split(' ') as any
        let wordCount = quotewords.length
        quote.innerHTML = ''
        for (let i = 0; i < wordCount; i++) {
          quote.innerHTML += `<span class="-fadeout">${quotewords[i]}</span>`
          if (i < quotewords.length - 1) {
            quote.innerHTML += ' '
          }
        }
        quotewords = slide.querySelectorAll(`${selector} span`)

        setTimeout(() => {
          fadeWords(quotewords, delayTimer, slide, callback)
        }, timeout)
      }

      function fadeWords (quotewords: HTMLElement[], delayTimer: number, slide: HTMLElement, callback?: () => void) {
        Array.prototype.forEach.call(quotewords, function (word: HTMLSpanElement) {
          word.style.transitionDelay = `${delayTimer}ms`
          word.style.transitionDuration = `${delayTimer}ms`
          if (slide.classList.contains('-active')) {
            word.classList.remove('-fadeout')
          }
        })

        setTimeout(() => {
          if (callback) {
            callback()
          }
        }, delayTimer)
      }

      splitWords('.js-topSlider-title', 600)

      // eslint-disable-next-line @typescript-eslint/no-empty-function
      splitWords('.js-topSlider-subTitle', 600, () => {}, 600)

      setTimeout(() => {
        const linkElement = slide.querySelector('.js-topSlider-link') as unknown as HTMLElement

        linkElement.classList.remove('-fadeout')
      }, 0)
    }, 1000)
  }

  /// Handle navigation
  const navigationDots = Array.from(topBannerWrapper.querySelectorAll('.js-topSlider-navSingle')) as unknown as HTMLElement[]
  navigationDots.forEach(navigationDot => {
    navigationDot.addEventListener('click', () => {
      navigateSlide(navigationDot)
    })
  })

  // Handle slide logic
  let slideInterval = false as unknown as any

  const setSlideInterval = () => {
    return setInterval(() => {
      if (currentSlide < slideList.length) {
        animateSlide(slideList[currentSlide])
      }
      else {
        currentSlide = 0
        animateSlide(slideList[currentSlide])
      }
    }, 7000)
  }

  const slideList = Array.from(topBannerWrapper.querySelectorAll('.js-topSlider-slide')) as unknown as HTMLElement[]

  if (slideList.length > 1) {
    animateSlide(slideList[currentSlide])

    slideInterval = setSlideInterval()

    if (slideList.length === 1) {
      animateSlide(slideList[0])
    }
  }
}
